"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sanner = _interopRequireDefault(require("@/utils/sanner"));
var _store = require("@/api/store");
var _newToExcel = _interopRequireDefault(require("@/utils/newToExcel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'scannerDialog',
  data: function data() {
    return {
      dialogVisible: false,
      scanner: null,
      scanList: [],
      queryIndex: -1,
      // 查询下标
      queryQueueWorking: false,
      //
      headers: [{
        label: '商品条码',
        prop: 'code',
        align: 'left',
        width: '180'
      }, {
        label: '商品名称',
        prop: 'goodsName',
        align: 'left',
        width: '350'
      }, {
        label: '商品类型',
        prop: 'goodsType',
        align: 'left',
        width: '250'
      }, {
        label: '描述',
        prop: 'description',
        align: 'left',
        width: '200'
      }, {
        label: '关键字',
        prop: 'keyword',
        align: 'left',
        width: '200'
      }, {
        label: '规格',
        prop: 'spec',
        align: 'left',
        width: '200'
      }, {
        label: '价格',
        prop: 'price',
        align: 'left',
        width: '200'
      }, {
        label: '高度',
        prop: 'hight',
        align: 'left',
        width: '200'
      }, {
        label: '宽度',
        prop: 'width',
        align: 'left',
        width: '200'
      }, {
        label: '深度',
        prop: 'depth',
        align: 'left',
        width: '200'
      }, {
        label: '毛重',
        prop: 'gw',
        align: 'left',
        width: '200'
      }, {
        label: '净重',
        prop: 'nw',
        align: 'left',
        width: '200'
      }, {
        label: '商品图片',
        prop: 'img',
        align: 'left',
        width: '200'
      }, {
        label: '图片列表',
        prop: 'imgList',
        align: 'left',
        width: '300'
      }, {
        label: '专题图片',
        prop: 'sptmImg',
        align: 'left',
        width: '300'
      }, {
        label: '商标',
        prop: 'trademark',
        align: 'left',
        width: '120'
      }, {
        label: '生产厂家地址',
        prop: 'manuName',
        align: 'left',
        width: '200'
      }, {
        label: '生产厂家名称',
        prop: 'manuAddress',
        align: 'left',
        width: '200'
      }, {
        label: '原产地',
        prop: 'ycg',
        align: 'left',
        width: '200'
      }, {
        label: '标志',
        prop: 'flag',
        align: 'left',
        width: '120'
      }, {
        label: 'GPC分类代码',
        prop: 'gpc',
        align: 'left',
        width: '120'
      }, {
        label: 'GPC类型',
        prop: 'gpcType',
        align: 'left',
        width: '120'
      }, {
        label: 'QS 认证',
        prop: 'qs',
        align: 'left',
        width: '120'
      }, {
        label: '备注',
        prop: 'remark',
        align: 'left',
        width: '180'
      }, {
        label: '备注说明',
        prop: 'note',
        align: 'left',
        width: '500'
      }]
    };
  },
  computed: {
    codes: function codes() {
      return this.scanList.map(function (item) {
        return item.code;
      });
    }
  },
  mounted: function mounted() {
    this.scannerInit();
  },
  watch: {
    'scanList.length': function scanListLength(newVal, oldVal) {
      if (newVal - 1 > this.queryIndex && !this.queryQueueWorking) {
        this.onQuery();
      }
    }
  },
  methods: {
    openDialog: function openDialog() {
      this.scanList = [];
      this.queryIndex = -1;
      this.dialogVisible = true;
      if (this.scanner) {
        this.scanner.start();
      }
    },
    closeDialog: function closeDialog() {
      if (this.scanner) {
        this.scanner.stop();
      }
      this.dialogVisible = false;
    },
    scannerInit: function scannerInit() {
      var _this = this;
      this.scanner = new _sanner.default(function (code) {
        if (_this.codes.indexOf(code) === -1) {
          _this.scanList.push({
            code: code
          });
          _this.tableScrollBottom();
        }
      });
    },
    onQuery: function onQuery() {
      var index = this.queryIndex + 1;
      if (index < this.scanList.length) {
        this.queryIndex++;
        this.queryQueueWorking = true;
        this.getInfo(index);
      } else {
        this.queryQueueWorking = false;
      }
    },
    getInfo: function () {
      var _getInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(codeIndex) {
        var code, obj, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              code = this.scanList[codeIndex].code;
              _context.p = 1;
              _context.n = 2;
              return (0, _store.getBarcodeInfo)(code);
            case 2:
              res = _context.v;
              if (res.showapi_res_code === 0 && res.showapi_res_body) {
                obj = res.showapi_res_body;
                obj.status = 1;
              } else {
                obj = {
                  code: code,
                  status: 0
                };
              }
              this.$set(this.scanList, codeIndex, obj);
              this.tableScrollBottom();
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              obj = {
                code: code,
                status: 0
              };
              this.$set(this.scanList, codeIndex, obj);
            case 4:
              _context.p = 4;
              this.onQuery();
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getInfo(_x) {
        return _getInfo.apply(this, arguments);
      }
      return getInfo;
    }(),
    tableScrollBottom: function tableScrollBottom() {
      var _this2 = this;
      this.$nextTick(function () {
        var wrapper = _this2.$refs.tableRef.$el.querySelector('.el-table__body-wrapper');
        wrapper.scrollTop = wrapper.scrollHeight;
      });
    },
    getExcelData: function getExcelData() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var header = [],
          filekey = [];
        _this3.headers.forEach(function (item) {
          header.push(item.label);
          filekey.push(item.prop);
        });
        var exportData = _this3.scanList.map(function (item) {
          var o = {};
          filekey.forEach(function (head) {
            o[head] = item[head];
          });
          return o;
        });
        resolve({
          header: header,
          filekey: filekey,
          exportData: exportData
        });
      });
    },
    exportFile: function () {
      var _exportFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var date, tableData;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              date = new Date().toLocaleString('zh-CN', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
              });
              _context2.n = 1;
              return this.getExcelData();
            case 1:
              tableData = _context2.v;
              (0, _newToExcel.default)(tableData.header, tableData.filekey, "\u626B\u7801\u5546\u54C1\u4FE1\u606F - ".concat(date), tableData.exportData);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function exportFile() {
        return _exportFile.apply(this, arguments);
      }
      return exportFile;
    }()
  }
};